/**
 * Default display text for the Current Password Field.
 */
export const defaultCurrentPasswordFieldDisplayText = {
    label: 'Current password',
    requiredMessage: 'Please enter your current password.',
    formatMessage: 'The current password you entered is invalid.',
    lengthMessage: 'Your current password must contain less than ${maxLength} characters.'
};
//# sourceMappingURL=display-text.js.map